import { FC } from 'react';
import { Card, Row, Typography } from 'antd';

import { ISectionProps } from './types';

const { Title } = Typography;

const Section: FC<ISectionProps> = ({ title, children }) => {
  return (
    <Card style={{ marginBottom: 24 }}>
      <Row
        style={{ marginBottom: 'var(--margin-md)' }}
        justify="space-between"
        align="middle"
      >
        <Title level={4} style={{ margin: 0 }}>
          {title}
        </Title>
      </Row>
      {children}
    </Card>
  );
};

export default Section;
